"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsonToQs = function (json) {
    return Object.keys(json)
        // tslint:disable-next-line:no-any
        .map(function (key) { return json[key] ? key + "=" + json[key] : ''; })
        .join('&');
};
function createHttpGetFunction(path) {
    return function (client) { return function (_a) {
        var body = _a.body, headers = _a.headers, host = _a.host, logger = _a.logger, port = _a.port, scheme = _a.scheme;
        var query = body ? jsonToQs(body) : undefined;
        var clientRequest = client.makeRequest({
            headers: headers,
            method: 'GET',
            uri: {
                host: host,
                path: path,
                port: port,
                scheme: scheme,
                query: query,
            },
        });
        return new Promise(function (resolve, reject) {
            return clientRequest.then(function (_a) {
                var responseBody = _a.responseBody, responseHeaders = _a.responseHeaders, responseStatusCode = _a.responseStatusCode;
                try {
                    // No Content
                    if (responseStatusCode === 204) {
                        resolve({
                            code: responseStatusCode,
                            data: undefined,
                        });
                        return;
                    }
                    var data = JSON.parse(responseBody);
                    if (responseStatusCode >= 400 || data && data.errors) {
                        var errorObject = __assign({ code: responseStatusCode }, data);
                        reject(errorObject);
                        return;
                    }
                    resolve({
                        code: responseStatusCode,
                        data: data,
                    });
                }
                catch (err) {
                    if (logger) {
                        logger.error('Cannot parse responseBody', {
                            err: err,
                            response: {
                                responseBody: responseBody,
                                responseHeaders: responseHeaders,
                                responseStatusCode: responseStatusCode,
                            },
                            request: {
                                method: 'GET',
                                uri: {
                                    headers: headers,
                                    host: host,
                                    path: path,
                                    port: port,
                                    scheme: scheme,
                                    query: query,
                                },
                            },
                        });
                    }
                    else {
                        console.error('cannot parse responseBody', JSON.stringify({
                            err: err,
                            response: {
                                responseBody: responseBody,
                                responseHeaders: responseHeaders,
                                responseStatusCode: responseStatusCode,
                            },
                            request: {
                                method: 'GET',
                                uri: {
                                    headers: headers,
                                    host: host,
                                    path: path,
                                    port: port,
                                    scheme: scheme,
                                    query: query,
                                },
                            },
                        }));
                    }
                    reject(err);
                }
            })
                .catch(reject);
        });
    }; };
}
exports.createHttpGetFunction = createHttpGetFunction;
function createHttpPostFunction(path) {
    return function (client) { return function (_a) {
        var body = _a.body, headers = _a.headers, host = _a.host, logger = _a.logger, port = _a.port, scheme = _a.scheme;
        var json = JSON.stringify(body);
        var clientRequest = client.makeRequest({
            body: json,
            headers: headers,
            method: 'POST',
            uri: {
                host: host,
                path: path,
                port: port,
                scheme: scheme,
            },
        });
        return new Promise(function (resolve, reject) {
            return clientRequest.then(function (_a) {
                var responseBody = _a.responseBody, responseHeaders = _a.responseHeaders, responseStatusCode = _a.responseStatusCode;
                try {
                    // No Content
                    if (responseStatusCode === 204) {
                        resolve({
                            code: responseStatusCode,
                            data: undefined,
                        });
                        return;
                    }
                    var data = JSON.parse(responseBody);
                    if (responseStatusCode >= 400 || data.errors) {
                        var errorObject = __assign({ code: responseStatusCode }, data);
                        reject(errorObject);
                        return;
                    }
                    resolve({
                        code: responseStatusCode,
                        data: JSON.parse(responseBody),
                    });
                }
                catch (err) {
                    if (logger) {
                        logger.error('Cannot parse responseBody', {
                            err: err,
                            response: {
                                responseBody: responseBody,
                                responseHeaders: responseHeaders,
                                responseStatusCode: responseStatusCode,
                            },
                            request: {
                                json: json,
                                method: 'POST',
                                headers: headers,
                                uri: {
                                    host: host,
                                    path: path,
                                    port: port,
                                    scheme: scheme,
                                },
                            },
                        });
                    }
                    else {
                        console.error('cannot parse responseBody', JSON.stringify({
                            err: err,
                            response: {
                                responseBody: responseBody,
                                responseHeaders: responseHeaders,
                                responseStatusCode: responseStatusCode,
                            },
                            request: {
                                json: json,
                                method: 'POST',
                                headers: headers,
                                uri: {
                                    host: host,
                                    path: path,
                                    port: port,
                                    scheme: scheme,
                                },
                            },
                        }));
                    }
                    reject(err);
                }
            })
                .catch(reject);
        });
    }; };
}
exports.createHttpPostFunction = createHttpPostFunction;
//# sourceMappingURL=index.js.map